import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import toastService from "Root/profile/toastService";
import { apiCreatePaypalToken, apiGetPayPalId } from "Root/api/apiCheckout";
import { Loading } from "CheckoutComponents";
import styles from "./styles.module.scss";
const PayPalButtonNew = (props) => {
    const [paypalIsLoaded, setPaypalIsLoaded] = useState(false);
    function createClient(auth) {
        window.braintree.client
            .create({
            authorization: auth,
        })
            .then((clientInstance) => window.braintree.paypalCheckout.create({
            client: clientInstance,
        }))
            .then((paypalCheckoutInstance) => paypalCheckoutInstance.loadPayPalSDK({
            vault: true,
            commit: false,
            intent: "tokenize",
        }))
            .then((paypalCheckoutInstance) => window.paypal
            .Buttons({
            style: {
                height: 55,
                label: "paypal",
                color: "gold",
                shape: "rect",
                tagline: false,
            },
            onShippingChange(data, actions) {
                if (data.shipping_address.country_code !== "US" && data.shipping_address.country_code !== "CA") {
                    return actions.reject();
                }
            },
            fundingSource: window.paypal.FUNDING.PAYPAL,
            createBillingAgreement() {
                const billingagreement = `Your total is ${props.total}. Your plan will renew every ${props.deliveryFreq} days at the price of ${props.recurringPrice} plus taxes & fees, unless you pause, edit, or cancel your subscription. Please ensure your shipping address below is correct.`;
                return paypalCheckoutInstance.createPayment({
                    flow: "vault",
                    billingAgreementDescription: billingagreement.slice(0, 255),
                    enableShippingAddress: true,
                    shippingAddressEditable: true,
                    displayName: "Gainful Health Inc.",
                    amount: 0,
                    currency: "USD",
                });
            },
            onApprove(data) {
                props.setLoading(true);
                return paypalCheckoutInstance.tokenizePayment(data, (err, payload) => {
                    const addon_cart_str = JSON.stringify({ userCart: props.userCart });
                    // Submit `payload.nonce` to your server.
                    data = {
                        // @ts-ignore
                        nonce: payload.nonce,
                        shipAddress: payload.details.shippingAddress,
                        billAddress: payload.details.billingAddress,
                        addon_cart: addon_cart_str,
                        paymentType: "paypal",
                        shippingSpeed: "standard",
                        ecomm: true,
                        email: payload.details.email
                    };
                    props.setPaypalData(data);
                    props.setLoading(false);
                }); // end tokenizePayment
            },
            onCancel(data) {
                console.log("paypal checkout cancelled", JSON.stringify(data));
            },
            onError(err) {
                console.error("paypal error", err);
                props.setLoading(false);
            },
        })
            .render("#paypal-button-1"))
            .then(() => {
            // The PayPal button will be rendered in an html element with the ID
            // `paypal-button`. This function will be called when the PayPal button
            // is set up and ready to be used
            setPaypalIsLoaded(true);
        })
            .catch((err) => {
            console.log("error: ", err);
            props.setLoading(false);
        });
    }
    const renderBraintree = async () => {
        try {
            const data = await apiCreatePaypalToken({});
            createClient(data.token);
        }
        catch (err) {
            toastService.errorMessage("Something went wrong");
        }
    };
    const renderPaypalButton = async () => {
        try {
            const data = await apiGetPayPalId();
            const script = document.createElement("script");
            script.src = `https://www.paypal.com/sdk/js?client-id=${data.paypalClientID}`;
            script.onload = renderBraintree;
            document.body.appendChild(script);
        }
        catch (e) {
            toastService.errorMessage("Something went wrong");
        }
        setPaypalIsLoaded(false);
    };
    useEffect(() => {
        renderPaypalButton();
    }, []);
    return (_jsxs(_Fragment, { children: [!paypalIsLoaded && _jsx(Loading, {}), _jsx("div", { className: `${styles.paypalwrapper} ${!paypalIsLoaded && styles.loading}`, id: "paypal-button-1", style: { zIndex: 0 } })] }));
};
export default PayPalButtonNew;
